import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function OverthinkPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboardingV1.overthink.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-orange"
          emoji="🥱"
          label={t("pages.onboardingV1.frequency.always")}
          name={t("pages.onboardingV1.overthink.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.frequency.always", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="😩"
          label={t("pages.onboardingV1.frequency.often")}
          name={t("pages.onboardingV1.overthink.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.frequency.often", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="😐"
          label={t("pages.onboardingV1.frequency.sometimes")}
          name={t("pages.onboardingV1.overthink.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.frequency.sometimes", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-blue"
          emoji="😎"
          label={t("pages.onboardingV1.frequency.rarely")}
          name={t("pages.onboardingV1.overthink.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.frequency.rarely", { lng: "en" })}
        />
      </Form>
    </Layout>
  )
}
